import * as HLF from "html-living-framework";
import {Container} from "../core/Container";
import {Spine} from "../core/Spine";
import {Assets} from "../data/Assets";
import {CaptionToken} from "../data/CaptionToken";
import {CharacterType} from "../data/CharacterType";

export abstract class AbstractCharacter extends Container {

    public readonly characterType: CharacterType;
    public readonly characterSpine: Spine;

    private _isTalking = false;

    get isTalking(): boolean {
        return this._isTalking;
    }

    constructor(characterType: CharacterType) {
        super();

        this.characterType = characterType;
        this.characterSpine = this.addChild(new Spine(
            Assets.characters[this.characterType]!.getAsset(),
        ));

        this.characterSpine.setMixes(0);
        this.characterSpine.autoUpdate = true;
        this.animateIdle();

        PubSub.subscribe(HLF.VOICEOVER_STARTED, this.onPlayCaption);
        PubSub.subscribe(HLF.VOICEOVER_ENDED, this.onStopCaption);

        PubSub.subscribe(HLF.GAME_PAUSED, this.onPause);
        PubSub.subscribe(HLF.GAME_UNPAUSED, this.onResume);
    }

    public startTalk() {
        if (!this._isTalking) {
            this._isTalking = true;
            this.animateTalk();
        }
    }

    public stopTalk() {
        if (this._isTalking) {
            this._isTalking = false;
            this.animateIdle();
        }
    }

    public destroy() {
        PubSub.unsubscribe(this.onPlayCaption);
        PubSub.unsubscribe(this.onStopCaption);
        PubSub.unsubscribe(this.onPause);
        PubSub.unsubscribe(this.onResume);
        super.destroy();
    }

    protected isCharacterCC(id: string) {
        return id.indexOf(this.characterType) >= 0;
    }

    protected abstract animateIdle(): void;

    protected abstract animateTalk(): void;

    private readonly onPlayCaption = (topic: string, token: CaptionToken) => {
        if (token && this.isCharacterCC(token.id)) {
            this.startTalk();
        } else {
            this.stopTalk();
        }
    }

    private readonly onStopCaption = () => {
        this.stopTalk();
    }

    private readonly onPause = () => {
        this.characterSpine.autoUpdate = false;
    }

    private readonly onResume = () => {
        this.characterSpine.autoUpdate = true;
    }

    set width(value: number) {
        // not resizable
    }

    set height(value: number) {
        // not resizable
    }
}
